import * as React from 'react';
import { findDOMNode } from 'react-dom';
import cn from 'classnames';

import { Search } from '@weddingspot/ws-api-client';
import { TypeaheadSearchResults, useTypeahead } from '@weddingspot/ws-core-components';
const { ChevronRightIcon, XIcon } = require('@cvent/carina-icon');
import { MARKETS, Market } from '../../data/regions';

const _styles = require('./LocationSearchFilter.scss');

interface LocationSearchFilterProps {
    onMarketSelected?: (market: Market) => void;
    marketLinks?: Search.RelativeUrl[];
    onSearchResultClick?: () => void;
}

const comparMarkets = (a: Market, b: Market) => {
    const keyA = a.market;
    const keyB = b.market;

    let comparison = 0;
    if (keyA > keyB) {
        comparison = 1;
    } else if (keyA < keyB) {
        comparison = -1;
    }
    return comparison;
};

export const LocationSearchFilter = (props: LocationSearchFilterProps) => {
    const [search, setSearch] = React.useState('');
    const [content, setContent] = React.useState<'markets' | 'search'>('markets');
    const { storeState, storeActions } = useTypeahead();
    const { matchedLocations, matchedStyles, matchedVenues, isLoad } = storeState;
    const inputRef = React.useRef(null);
    const marketLinks = props.marketLinks || null;

    React.useEffect(() => {
        if (inputRef.current) {
            (findDOMNode(inputRef.current) as HTMLInputElement).focus();
        }
    });

    return (
        <>
            <div className={_styles.searchInputContainer}>
                <input
                    className={_styles.searchInput}
                    type='text'
                    placeholder='Search by venue, location or style'
                    onChange={(e) => {
                        const val = e.target.value;
                        setSearch(val);
                        if (!val) {
                            setContent('markets');
                        } else {
                            setContent('search');
                            storeActions.setQ(val);
                        }
                    }}
                    value={search}
                    ref={inputRef}
                />
                <div
                    className={cn(_styles.searchXIcon, { [_styles.hidden]: !search })}
                    onClick={() => {
                        setSearch('');
                        setContent('markets');
                    }}
                >
                    <XIcon color='#69717A' />
                </div>
            </div>
            <div className={_styles.body}>
                {content === 'markets' && !marketLinks && (
                    <>
                        {MARKETS.sort(comparMarkets).map((market, idx) => {
                            return (
                                <div
                                    className={_styles.marketRow}
                                    key={idx}
                                    onClick={() => {
                                        setSearch(market.market);
                                        props.onMarketSelected && props.onMarketSelected(market);
                                    }}
                                >
                                    <div className={_styles.marketRowContent}>
                                        <div className={_styles.marketLabel}>{market.market}</div>
                                        <div className={_styles.marketIcon}>
                                            <ChevronRightIcon size='m' color='#881155' />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </>
                )}
                {content === 'markets' && marketLinks && (
                    <>
                        {marketLinks.map((market, index) => {
                            return (
                                <div className={_styles.marketRow} key={index}>
                                    <a href={market.url}>
                                        <div className={_styles.marketRowContent}>
                                            <div className={_styles.marketLabel}>{market.label}</div>
                                            <div className={_styles.marketIcon}>
                                                <ChevronRightIcon size='m' color='#881155' />
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            );
                        })}
                    </>
                )}
                {content === 'search' && (
                    <div>
                        <TypeaheadSearchResults
                            venues={matchedVenues}
                            locations={matchedLocations}
                            styles={matchedStyles}
                            keyboardSelectedIndex={null}
                            onClick={props.onSearchResultClick}
                        />
                        {!isLoad && <span style={{ paddingLeft: '16px' }}>Loading...</span>}
                    </div>
                )}
            </div>
        </>
    );
};
